module.exports = __webpack_public_path__ + "img/gywm-8.dc7377db.jpg";